/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 7/26/19
 *
 */

import Vue from "@/entry/setupVue3.js"
import 'reflect-metadata'
import AuthManagerLight from "@/entry/genogram/AuthManagerLight";

let authManager = new AuthManagerLight()


Vue.config.globalProperties.$authManager = authManager

